import { User } from '@features/auth/hooks/types'

export const SystemRole = {
  user: 'member',
  admin: 'admin',
} as const

export type SystemRoles = (typeof SystemRole)[keyof typeof SystemRole]

export const isHasAccess = (
  requiredRole?: (typeof SystemRole)[keyof typeof SystemRole],
  user?: User | null
): boolean => {
  if (!user) {
    return false
  }
  if (requiredRole === 'member' || !requiredRole) {
    return true
  }
  return user?.role === requiredRole
}
